import { UserRole } from '../shared/auth.roles';

export const environment = {
  production: process.env.NODE_ENV === 'production',
  
  // API & URLs
  API_URL: process.env.API_URL || '',
  HISTORY_API_URL: process.env.HISTORY_API_URL || '',
  IMAGE_URL: process.env.IMAGE_URL || '',
  BASE_URL: process.env.BASE_URL || '',
  SOCKET_URL: process.env.SOCKET_URL || '',
  
  // Analytics / Keys
  CLOUDFLARE_CAPTCHA_SITEKEY: process.env.CLOUDFLARE_CAPTCHA_SITEKEY || '',
  GOOGLE_ANALYTICS_TRACKING_ID: process.env.GOOGLE_ANALYTICS_TRACKING_ID || '',

  GOOGLE_KEY: process.env.GOOGLE_KEY || '',
  buyUrl: process.env.BUY_URL || '',
  SCARF_ANALYTICS: false,
  adminRoot: process.env.ADMIN_ROOT || '/app',
  apiUrl: process.env.API_URL || '',

  // UI / Layout
  defaultMenuType: process.env.DEFAULT_MENU_TYPE || 'menu-default',
  subHiddenBreakpoint: parseInt(process.env.SUB_HIDDEN_BREAKPOINT || '1442', 10),
  menuHiddenBreakpoint: parseInt(process.env.MENU_HIDDEN_BREAKPOINT || '768', 10),
  themeColorStorageKey: process.env.THEME_COLOR_STORAGE_KEY || 'vien-themecolor',
  isMultiColorActive: process.env.IS_MULTI_COLOR_ACTIVE === 'true',
  defaultColor: process.env.DEFAULT_COLOR || 'light.blueyale',
  isDarkSwitchActive: process.env.IS_DARK_SWITCH_ACTIVE === 'true',
  defaultDirection: process.env.DEFAULT_DIRECTION || 'ltr',
  themeRadiusStorageKey: process.env.THEME_RADIUS_STORAGE_KEY || 'vien-themeradius',
  
  // Auth
  isAuthGuardActive: process.env.IS_AUTH_GUARD_ACTIVE === 'true',
  defaultRole: UserRole.Admin,

  // Firebase
  firebase: {
    apiKey: process.env.FIREBASE_API_KEY || '',
    authDomain: process.env.FIREBASE_AUTH_DOMAIN || '',
    databaseURL: process.env.FIREBASE_DB_URL || '',
    projectId: process.env.FIREBASE_PROJECT_ID || '',
    storageBucket: process.env.FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID || '',
    appId: process.env.FIREBASE_APP_ID || '',
    measurementId: process.env.FIREBASE_MEASUREMENT_ID || ''
  }
};
